import {connect} from 'react-redux';
import {
  homepageSelector,
  homepageLoadingSelector
} from '../../../reducers';
import Intro from './component';

const mapStateToProps = (state) => {
  return {
    homepage: homepageSelector(state) || {},
    loading: homepageLoadingSelector(state) ? true : false,
  };
};

export default connect(mapStateToProps)(Intro);



// WEBPACK FOOTER //
// ./src/component/organisms/Intro/index.js